module.exports = __webpack_public_path__ + "img/compressed-2018235990044446720.f132d2e1.png";